<template>
  <div>
    <v-container fluid>
      <date-filter
        v-model="selectedDate"
        :default-filter="'today'"
        @changeDate="onDateChanged"
      ></date-filter>
    </v-container>
    <v-container class="pb-9" style="padding-bottom: 90px !important">
      <v-data-table
        :rows-per-page-items="[25, 40, 50, 100]"
        :loading="loading"
        :headers="headers"
        :items="items"
        class="elevation-1"
      >
        <template #items="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </td>
            <td class="text-xs-left">{{ props.item.adminmessage }}</td>
            <td class="text-xs-left">{{ props.item.vulgarity }}</td>
            <td class="text-xs-left">{{ props.item.adminname }}</td>
            <td class="test-xs-left">
              <v-btn
                :href="'https://business.facebook.com/latest/' + props.item.userid"
                target="_blank"
                small
                :disabled="!props.item.inboxurl"
                depressed
                round
                color="#3b5998"
                :dark="props.item.inboxurl ? true : false"
              >
                <em class="fab fa-facebook-square mr-1" />
                {{ $t('View inbox') }}
              </v-btn>
            </td>
            <td class="text-xs-center" style="white-space: nowrap">
              <div v-if="props.item.qa == null">
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  color="#55d85b"
                  small
                  style="color: white; width: 3.5em; min-width: 0"
                  @click="qaUpdate(props.item, true)"
                >
                  <em class="fas fa-check" />
                </v-btn>
                <v-btn
                  depressed
                  :disabled="loadingBtn == props.item.id"
                  :loading="loadingBtn == props.item.id"
                  color="#ff7166"
                  small
                  style="color: white; width: 3.5em; min-width: 0"
                  @click="qaUpdate(props.item, false)"
                >
                  <em class="fas fa-times" />
                </v-btn>
              </div>
              <div v-else>
                <div
                  v-if="props.item.qa"
                  style="color: #55d85b; font-weight: 600; cursor: pointer"
                  @click="props.item.qa = null"
                >
                  ผ่าน
                  <em style="color: grey" class="fas fa-pencil-alt" />
                </div>
                <div
                  v-else
                  style="color: #ff7166; font-weight: 600; cursor: pointer"
                  @click="props.item.qa = null"
                >
                  ไม่ผ่าน
                  <em style="color: grey" class="fas fa-pencil-alt" />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import DateFilter from '../../DateFilter.vue'
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    DateFilter
  },
  data() {
    return {
      data: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      headers: [
        { text: 'เวลา', value: 'time', align: 'center' },
        { text: 'ข้อความแอดมิน', value: 'Admin_text' },
        { text: 'คำหยาบที่ลูกค้าพิมพ์', value: 'vulgarity' },
        { text: 'ชื่อแอดมินที่พิมพ์', value: 'Admin_name' },
        { text: '', value: '' },
        { text: 'QA', value: 'qa', align: 'center', sortable: false }
      ],
      items: [],
      loading: true,
      loadingBtn: ''
    }
  },
  mounted() {
    this.getastonqaadminchatlog()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    openPopUp(url) {
      window.open(
        url,
        '_blank',
        'toolbar=yes,scrollbars=yes,resizable=yes,top=0,width=1000,height=900'
      )
    },
    getastonqaadminchatlog() {
      this.loading = true
      api.getastonqaadminchatlog(
        {
          datefrom: this.selectedDate.start,
          dateto: this.selectedDate.end,
          pageid: this.selectedBot.pageid
        },
        (error, response) => {
          this.items = response.data
          this.loading = false
        }
      )
    },
    onDateChanged() {
      this.getastonqaadminchatlog()
    },
    qaUpdate(item, qa) {
      this.loadingBtn = item.id
      api.putastonqaadminchatlog(
        { id: item.id, userid: item.userid, timestamp: item.timestamp, qa },
        (err, response) => {
          if (response.responsecode == 200) {
            this.loadingBtn = ''
            item.qa = qa
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/aston/AstonDashboardAdminMessage.vue